import React, { Component } from 'react';
import './mini-card.css';

export default class MiniCard extends Component {
  constructor(props) {
    super(props);

    this.cardRef = React.createRef();

    this.state = {
      "card_height": 0
    };
  }

  componentDidMount() {
    var width = this.cardRef.current.offsetWidth;
    var calc = width / 428 * 1;
    this.setState({
      "card_height": 290 * calc
    })
  }

  render() {
    return (
      <div className={`rdp-react-template-component-mini-card ${this.props.disabled ? "disabled" : ""}`} style={{width: this.props.fullscreen ? "100%" : "300px"}} onClick={() => this.props.onClick && this.props.onClick()}>
        <div ref={this.cardRef} className="rdp-react-template-component-mini-card-cover" style={{
          backgroundImage: `url(${this.props.thumb})`,
          height: `${this.state.card_height}px`
          // height: this.props.fullscreen ? "220px" : "140px"
        }}>
          {/* <span className="rdp-react-template-component-mini-card-localization">{this.props.localization}</span> */}
        </div>
        <div className="rdp-react-template-component-mini-card-info">
          {this.props.name && <span className="rdp-react-template-component-mini-card-name">{this.props.name}</span>}
          <div className="rdp-react-template-component-mini-card-info-container">
            {this.props.tag && <span className="rdp-react-template-component-mini-card-tag">{this.props.tag}</span>}
            {this.props.duration && <span className="rdp-react-template-component-mini-card-duration">{this.props.duration}</span>}
          </div>

          <div className="rdp-react-template-component-mini-card-info-flex">
            <div className="rdp-react-template-component-mini-card-info-flex-item">
              {this.props.price && <span className="rdp-react-template-component-mini-card-price">R${this.props.price}</span>}
            </div>
          </div>
          
          
        </div>
      </div>
    );
  }
}
